// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Mf9H","right":"styles_right__35ubr"};